import { combineReducers, createStore, applyMiddleware } from "redux";
import { browserHistory } from "react-router";
import { composeWithDevTools } from "redux-devtools-extension";
import { routerMiddleware } from "react-router-redux";
import thunk from "redux-thunk";
import { reducer as globals } from "@redux/globals";
import reducers from "./reducers";

/**
 * Function to patchReducer and apply
 * globals actions reducer
 *
 * @param {Function} appReducer
 */
const patchReducer = appReducer => (state, action) => appReducer(globals(state, action), action);

const composeEnhancers = composeWithDevTools({
	trace: true,
	traceLimit: 25,
});

export default () => {
	const middleware = [routerMiddleware(browserHistory), thunk];

	/* ------------- Assemble Reducers ------------- */
	const appReducer = combineReducers(reducers);

	return createStore(patchReducer(appReducer), composeEnhancers(applyMiddleware(...middleware)));
};
